import Link from "next/link";
import { Stepper } from "@/components/ui/stepper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CART_STEPS = [
  { number: 1, label: "Add To Cart" },
  { number: 2, label: "Address" },
  { number: 3, label: "Payment" },
];

export default function CartPageSkeleton() {
  return (
    <section className="bg-background pt-32 xl:pt-44 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1440px] mx-auto">

        {/* Breadcrumb + Stepper Row — static */}
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between">
          <nav className="flex items-center gap-3">
            <Link
              href="/"
              className="font-oswald font-normal text-[18px] leading-[100%] tracking-[-0.02em] uppercase text-neutral-300 hover:text-neutral-500 transition-colors"
            >
              Home
            </Link>
            <span className="font-normal text-[18px] leading-[100%] tracking-[-0.02em] text-neutral-300">
              /
            </span>
            <span className="font-oswald font-normal text-[20px] leading-[100%] tracking-[-0.02em] uppercase text-neutral-500">
              Add To Cart
            </span>
          </nav>
          <div className="w-full sm:w-[350px] mt-6 sm:mt-0">
            <Stepper steps={CART_STEPS} currentStep={1} />
          </div>
        </div>

        {/* Page Title — "Cart" static, count dynamic */}
        <div className="mt-9 flex flex-col gap-2">
          <h1 className="font-oswald font-normal text-[20px] leading-[100%] tracking-[-0.02em] uppercase text-neutral-500">
            Cart
          </h1>
          <Skeleton width={160} height={20} />
        </div>

        {/* Table Skeleton — dynamic */}
        <div className="w-full py-[75px] flex flex-col gap-6">
          <div className="w-screen relative -left-4 sm:-left-6 lg:-left-10 border-t border-stroke-light" />

          {/* Desktop Header */}
          <div className="hidden md:flex items-center gap-30">
            {[1, 2, 3, 4].map((col) => (
              <div key={col} className="w-[219px]">
                <Skeleton width={100} height={24} />
              </div>
            ))}
          </div>

          <div className="w-screen relative -left-4 sm:-left-6 lg:-left-10 border-t border-stroke-light" />

          {/* 2 skeleton item rows */}
          {[1, 2].map((row) => (
            <div key={row} className="flex flex-col md:flex-row md:items-center justify-between py-4 gap-4 md:gap-0">
              <div className="flex items-center gap-[17px] w-full md:w-[219px]">
                <Skeleton width={50} height={50} borderRadius={6} />
                <Skeleton width={140} height={20} />
              </div>
              <div className="w-full md:w-[219px]">
                <Skeleton width={80} height={20} />
              </div>
              <div className="w-full md:w-[219px]">
                <Skeleton width={180} height={56} borderRadius={12} />
              </div>
              <div className="w-full md:w-[219px]">
                <Skeleton width={80} height={20} />
              </div>
              <div className="flex items-center gap-3">
                <Skeleton width={36} height={36} borderRadius={12} />
                <Skeleton width={36} height={36} borderRadius={12} />
              </div>
            </div>
          ))}
        </div>

        {/* Order Summary Skeleton — dynamic */}
        <div className="flex flex-col gap-5 w-full pb-20">
          <h2 className="font-oswald font-medium text-[20px] leading-[100%] tracking-[-0.02em] uppercase text-neutral-500">
            Order Summary
          </h2>
          <div className="w-full rounded-[20px] bg-background-50 px-5 py-[40px] flex flex-col gap-[30px]">
            <Skeleton width={80} height={20} />

            <div className="flex flex-col gap-5">
              {[1, 2].map((i) => (
                <div key={i} className="flex items-center justify-between">
                  <Skeleton width={192} height={20} />
                  <Skeleton width={80} height={20} />
                </div>
              ))}
            </div>

            <div className="w-full h-0 border-t border-stroke-light" />

            <div className="flex justify-between">
              <Skeleton width={128} height={20} />
              <Skeleton width={80} height={20} />
            </div>

            <div className="w-full h-0 border-t border-stroke-light" />

            <div className="flex items-center justify-between">
              <Skeleton width={128} height={20} />
              <Skeleton width={96} height={24} />
            </div>

            <Skeleton height={60} borderRadius={12} className="w-full" />
          </div>
        </div>

      </div>
    </section>
  );
}